import React, { useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTestSolution } from '../../../../actions/performanceAnalysisActions';
import './styles.scss';
import { Tab } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabPanel from '@material-ui/lab/TabPanel';
import SolutionImageSlider from './components/SolutionImageSlider';
import NoData from '../../../../components/NoData';
import { dateFormat } from '../../../../api/dateFormat';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import { Skeleton, TabList } from '@material-ui/lab';

export default function TestSolution(props) {
  // Variables
  let testID = props.testID;
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isFetching, setIsFetching] = React.useState(true);
  const [paperObj, setPaperObj] = React.useState({
    key: 'paper1',
    value: 'Paper- 01',
  });

  // Redux
  const dispatch = useDispatch();

  const jwt = useSelector((state) => get(state, 'loginReducer.data.jwt', ''));

  const paper =
    paperObj.key === 'paper1'
      ? useSelector((state) =>
          get(state, 'performanceAnalysisReducer.testSolution.paper1', [])
        )
      : useSelector((state) =>
          get(state, 'performanceAnalysisReducer.testSolution.paper2', [])
        );
  const testSolution = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.testSolution', [])
  );
  const paper2 = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.testSolution.paper2', [])
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (key, val) => {
    setAnchorEl(null);
    if (val !== 'backdropClick') {
      setPaperObj({
        key: key,
        value: val,
      });
    }
  };
  useEffect(() => {
    setIsFetching(true);
    fetchTestSolution(jwt, testID, dispatch).then(() => {
    setIsFetching(false);
    });
  }, []);

  const populateSubjectTab = () => {
    const list = [];
    (isFetching ? [1,1,1] : paper.listPaper[0].listSubject).map((data, index) => {
      list.push(<Tab label={isFetching ? <Skeleton width="80px"/> : data.SubjectName} value={index.toString()} />);
    });
    return list;
  };

  return (
    <React.Fragment>
      <div className="list-content flex">
        {(isFetching || (!isEmpty(testSolution) &&
          !isEmpty(paper) &&
          paper.listPaper.length > 0 &&
          paper.listPaper[0].listSubject.length > 0)) && (
            <div className="list-header">
              <h3 className="mb-5">{isFetching ? <Skeleton width="150px"/> : paper.TestName}</h3>
              {(isFetching || (!isEmpty(paper) && paper.TestDate)) && (
                <p className="sub-text">{isFetching ? <Skeleton width="100px"/> :dateFormat(paper.TestDate)}</p>
              )}
            </div>
          )}
        {(isFetching || (!isEmpty(testSolution) &&
          !isEmpty(paper2) &&
          paper2.listPaper.length > 0 &&
          paper2.listPaper[0].listSubject.length > 0)) && (
            <div className="paper-box">
              {isFetching ? <Skeleton width="90px" height="50px"/> :
              <Button variant="outlined" onClick={handleClick}>
                {paperObj.value}
                <span className="caret ml-10" />
              </Button>}
            </div>
          )}
      </div>

      {(isFetching || (!isEmpty(testSolution) &&
      !isEmpty(paper) &&
      paper.listPaper.length > 0 &&
      paper.listPaper[0].listSubject.length > 0)) ? (
        <div className="tab-design mt-10">
          <TabContext value=
          {value.toString()}>
            {(isFetching || (!isEmpty(testSolution) &&
              !isEmpty(paper) &&
              paper.listPaper.length > 0 &&
              paper.listPaper[0].listSubject.length > 0)) && (
                <TabList
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  className="line-tab"
                >
                  {populateSubjectTab()}
                </TabList>
              )}
            {(isFetching || (!isEmpty(testSolution) &&
              !isEmpty(paper) &&
              paper.listPaper &&
              paper.listPaper.length > 0)) && (
                <TabPanel value={value.toString()}>
                  {isFetching ? <Skeleton width="95%" height="500px"/> : <SolutionImageSlider
                    listQuestion={
                      paper.listPaper[0].listSubject[value].listQuestion
                    }
                  />}
                </TabPanel>
              )}
          </TabContext>
        </div>
      ) : (
        <>
          <div className="no-data-container">
            <NoData message={'No Solutions are available for this test'} />
          </div>
        </>
      )}
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleClose('paper1', 'Paper- 01')}>
          Paper- 1
        </MenuItem>
        <MenuItem onClick={() => handleClose('Paper2', 'Paper- 02')}>
          Paper -2
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
TestSolution.propTypes = {
  testID: PropTypes.string,
};
